import ApiGateway from "../Shared/ApiGateway.js";

class BooksRepository {
  constructor() {
    this.httpGateway = new ApiGateway();
  }

  getAllBooks = async () => {
    const allBooksDto = await this.httpGateway.get("/");
    return allBooksDto;
  };

  getPrivateBooks = async () => {
    const privateBooksDto = await this.httpGateway.get("/private");
    return privateBooksDto;
  };

  addBook = async ({ name, author }) => {
    const bookAddDto = await this.httpGateway.post("/", { name, author });
    return bookAddDto && bookAddDto.status === "ok" ? true : false;
  };
}

const booksRepository = new BooksRepository();
export default booksRepository;
